import React from "react";
import { getGatsbyImageData } from "gatsby-source-sanity";
import { GatsbyImage } from "gatsby-plugin-image";
import sanityConfig from "../../config/sanity";

const FigureCover = ({ input }) => {
  const imageData = getGatsbyImageData(
    input.asset,
    { maxWidth: 1700 },
    sanityConfig.sanity
  );
  const backgroundPlaceholder = input.asset.metadata
    ? input.asset.metadata.palette.dominant.background
    : "#fff";
  return (
    <figure
      className='h-full'
      style={{
        backgroundColor: backgroundPlaceholder
      }}>
      <GatsbyImage
        image={imageData}
        alt={"alt"}
        objectFit='cover'
        objectPosition='50% 50%'
        className='h-full'
      />
    </figure>
  );
};

export default FigureCover;
